import React, { useContext } from 'react';
import { createContext } from 'react';

import { StickyLayoutProps } from '../@types/StickyLayoutProps';

export const StickyLayoutContext = createContext<StickyLayoutProps>({} as StickyLayoutProps);

StickyLayoutContext.displayName = 'StickyLayout';

const StickyLayoutProvider = (props: StickyLayoutProps) => {
	const [isStuck, setIsStuck] = React.useState(false);

	return (
		<StickyLayoutContext.Provider value={{ ...props, isStuck, setIsStuck }}>
			{props.children}
		</StickyLayoutContext.Provider>
	);
};

export const useStickyLayout = () => {
	const context = useContext(StickyLayoutContext);

	return context;
};

export default StickyLayoutProvider;
